export default class FilterService {

  constructor($state, $q, ZakaznikService){
    this.$state = $state;
    this.$q = $q;
    this.ZakaznikService = ZakaznikService;
  }

  toOptions(list, valKey, labelKey){
    return list.map(item => ({value: item[valKey], label: item[labelKey]}));
  }

  withNull(list, label){
    return [{value: null, label: label}].concat(list);
  }

  withAny(list, label){
    return [{value: undefined, label: label}].concat(list);
  }

  withAnyNull(list, anyLabel, nullLabel){
    return this.withAny(this.withNull(list, nullLabel), anyLabel);
  }

  static setFilterToState($state, filter){
    var filterStr = JSON.stringify(filter);
    if(filterStr == "{}") filterStr=undefined;
    $state.go($state.current.name, {filter: filterStr});
  }

  getFilterFromStateParams($stateParams, defaultFilter = {}){
    return {
      ...defaultFilter,
      ...($stateParams.filter&&JSON.parse($stateParams.filter))||{}
    };
  }

  setFilterToState(filter){
    FilterService.setFilterToState(this.$state, filter);
  }

  /** implementacia business filtrov **/

  zakaznik(anyLabel = "Všetci zákazníci", nullLabel = "Žiaden zákazník") {
    return this.ZakaznikService.list().then(l => this.withAnyNull(this.toOptions(l, "id", "nazov"), anyLabel, nullLabel));
  }
}


// WEBPACK FOOTER //
// ./src/services/FilterService.js